<template>
    <div id="app" :class="{ 'dark-theme': this.verifyIsDarkTheme }">
        <div class="loading-page" v-if="isLoading">
            <b-spinner label="Spinning" :variant="'light'"></b-spinner>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../public/static/css/App-light-theme.css'
import '../public/static/css/App-dark-theme.css'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(Vuelidate)

export default {
    name: 'App',
    data() {
        return {
            isDarkTheme: false
        }
    },
    computed: {
        verifyIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        isLoading() {
            return this.$store.state.isLoading
        }
    },
    mounted() {
        this.isDarkTheme = this.$store.state.darkTheme
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue